<template>
  <div class="app-container">
    <el-button type="primary" size="small" @click="goBack">返回</el-button>
    <div style="padding-top: 10px"></div>
    <el-card>
      <el-form
          :model="slideImageDetail"
          ref="liveSlideImageForm"
          style="width: 60%"
          v-loading="uploadLoading"
      >
        <el-form-item
            label="图片标题"
            prop="title"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="slideImageDetail.title"/>
        </el-form-item>
        <el-form-item label="选择图片">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(slideImageDetail.faceUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="90px" label="是否启用">
          <el-switch active-text="启用" inactive-text="未启用" v-model="slideImageDetail.isEnabled"></el-switch>
        </el-form-item>
        <el-form-item
            label="类型"
            prop="type"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-select v-model="slideImageDetail.type" style="width: 100%">
            <el-option label="平台视频" :value="0"/>
            <el-option label="直播预告" :value="1"/>
            <el-option label="直播回顾" :value="2"/>
            <el-option label="平台外视频" :value="3"/>
            <el-option label="链接" :value="4"/>
          </el-select>
        </el-form-item>
        <el-form-item
            label="绑定视频ID"
            prop="bindId"
            v-if="slideImageDetail.type === 0 || slideImageDetail.type === 1 || slideImageDetail.type === 2"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input-number v-model="slideImageDetail.bindId"></el-input-number>
          <div class="el-upload__tip" style="color: #aaa">
            类型为视频时：绑定ID为视频ID
          </div>
          <div class="el-upload__tip" style="color: #aaa">
            类型为直播预告和直播回顾时：绑定ID为直播ID
          </div>
        </el-form-item>
        <el-form-item
            v-else
            label="链接地址"
            prop="linkUrl"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="slideImageDetail.linkUrl"></el-input>
        </el-form-item>
        <el-form-item
            v-if="userDataType.length > 0"
            label="所属领域"
            prop="userDataType"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-select v-model="slideImageDetail.userDataType" style="width: 100%">
            <el-option v-for="item in userDataType" :value="item.value" :key="item.value"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="updateSlideImage()">保存</el-button>
    </el-card>

  </div>

</template>

<script>
import {
  isVaild
} from "@/utils/validate";
import {
  addLiveSliderImage,
  getLiveSliderImageOne,
  updateLiveSliderImage
} from "@/api/CarouselManagement/CarouselManagement";
import {handleRes} from "@/utils/handleRes";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {getUserType} from "@/utils/userutil";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {deepClone} from "@/utils";

export default {
  name: "MaiLiveSliderImageDetail",
  created() {
    let queryId = this.$route.query.liveSildeImageId
    if (isVaild(queryId)) {
      this.liveSildeImageId = queryId
      this.getLiveSliderImageOne()
      this.userDataType = getUserType()
    }
  },
  data() {
    return {
      liveSildeImageId: -1,
      slideImageDetail: {},
      userDataType: [],
      uploadCoverFile: null,
      uploadCoverFileURL: "",
      uploadLoading: false, // 上传加载开关
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    getLiveSliderImageOne() {
      getLiveSliderImageOne({
        liveSildeImageId: this.liveSildeImageId
      }).then(res => {
        handleRes(res, () => {
          this.slideImageDetail = res.data
        })
      })
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    updateSlideImage() {
      this.$refs["liveSlideImageForm"].validate(async (valid) => {
        if (valid) {
          this.uploadLoading = true
          let savepathParamsRes = await getOSSUploadInfo({
            DataType: "25",
            ID: "0",
          });
          if (!isVaild(savepathParamsRes)) {
            this.uploadLoading = false
            return;
          }
          let savePathParams = savepathParamsRes.resultData

          //上传封面
          if (isVaild(this.uploadCoverFile)) {
            // printObj(this.uploadCoverFile.raw)
            let timestamp = new Date().valueOf();

            let uploadRes;
            let fileName;
            if (isVaild(this.uploadCoverFile)) {
              fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
              // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
              uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
                type: this.uploadCoverFile.raw.type
              }), fileName)
            }
            if (uploadRes.status === 0) {
              this.slideImageDetail.faceUrl = "/" + fileName
              // console.log(this.form.liveCover)
            } else {
              this.$message({
                type: "error",
                message: "上传失败"
              })
            }
            this.$refs.uploadCoverRef.clearFiles();
          }

          const params = deepClone(this.slideImageDetail);
          updateLiveSliderImage(params).then((res) => {
            handleRes(res, () => {
              this.$message('更新成功')
              this.getLiveSliderImageOne()
              this.uploadLoading = false
            })
          });
        } else {
          this.$message({
            type: "error",
            message: "请完善数据",
          });
        }
      });
    }
  }
}
</script>

<style scoped>

</style>